import { languageMap } from ".."

languageMap.hoon = {
	comments: {
		line: "::",
	},
}
